import {
  fetchStoreAppClassificationList,
  addStoreAppClassification,
  upDateStoreAppClassificationInfo,
  deleteStoreAppClassification,
  fetchStoreAppClassificationInfo
} from '@/api/appClassification';

const appClassification = {
  state: {
  },

  mutations: {
  },

  actions: {
    // 查询商店应用分类列表
    GetStoreAppClassificationList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreAppClassificationList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 查询商店应用分类
    GetStoreAppClassificationInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreAppClassificationInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 添加应用分类
    AddStoreAppClassification({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        addStoreAppClassification(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 修改应用分类
    UpDateStoreAppClassificationInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        upDateStoreAppClassificationInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 删除应用分类
    DeleteStoreAppClassification({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteStoreAppClassification(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default appClassification;



// WEBPACK FOOTER //
// ./src/store/modules/appClassification.js